import { RcsAgentBasicsStatus as RcsAgentBasicsStatusEnum } from "@redotech/cockroachdb-codegen/tables/shopper-ai/rcs-agent-basics-status";
import { RcsAgentRegistrationStatus as RcsAgentRegistrationStatusEnum } from "@redotech/cockroachdb-codegen/tables/shopper-ai/rcs-agent-registration-status";
import { RcsBrandRegistrationStatus as RcsBrandRegistrationStatusEnum } from "@redotech/cockroachdb-codegen/tables/shopper-ai/rcs-brand-registration-status";
import * as z from "zod";

/**
 * Telnyx RCS registration lifecycle, off the generated CRDB enums. Types widen
 * to the literal union so callers can compare against plain strings.
 */
export const RcsBrandRegistrationStatusSchema = z.enum(
  RcsBrandRegistrationStatusEnum,
);
export type RcsBrandRegistrationStatus = `${RcsBrandRegistrationStatusEnum}`;

/** `LIVE` is the only state that delivers RCS to anyone but a test device. */
export const RcsAgentRegistrationStatusSchema = z.enum(
  RcsAgentRegistrationStatusEnum,
);
export type RcsAgentRegistrationStatus = `${RcsAgentRegistrationStatusEnum}`;

/** Basics review, tracked separately from `status`; gates the testing phase. */
export const RcsAgentBasicsStatusSchema = z.enum(RcsAgentBasicsStatusEnum);
export type RcsAgentBasicsStatus = `${RcsAgentBasicsStatusEnum}`;
